import { documentsSectionMessages } from './documents-section-messages';

import type { MessageDescriptor } from 'react-intl';

const DOCUMENT_TYPE_LABELS: Record<string, MessageDescriptor> = {
  BILL_OF_LADING: documentsSectionMessages.billOfLading,
  PACKING_LIST: documentsSectionMessages.packingList,
  PALLET_LABEL: documentsSectionMessages.palletLabel,
  QUOTE: documentsSectionMessages.quote,
  PROOF_OF_DELIVERY: documentsSectionMessages.proofOfDelivery,
  WEIGHT_AND_INSPECTION: documentsSectionMessages.weightAndInspection,
  ACCESSORIALS_RECEIPT: documentsSectionMessages.accessorialsReceipt,
  BOL_PALLET_LABEL_COMBINED: documentsSectionMessages.bolPalletLabelCombined,
  CERTIFICATE_OF_INSURANCE: documentsSectionMessages.certificateOfInsurance,
  CERTIFICATE_OF_INSURANCE_INSTRUCTIONS: documentsSectionMessages.certificateOfInsuranceInstructions,
  CERTIFICATE_OF_ORIGIN_US: documentsSectionMessages.certificateOfOriginUs,
  CERTIFICATE_OF_ORIGIN_USMCA: documentsSectionMessages.certificateOfOriginUsmca,
  CERTIFICATE_OF_ORIGIN_USMCA_INSTRUCTIONS: documentsSectionMessages.certificateOfOriginUsmcaInstructions,
  INTERNATIONAL_COMMERCIAL_INVOICE: documentsSectionMessages.internationalCommercialInvoice,
  PALLET_LABEL_4X6: documentsSectionMessages.palletLabel4x6,
};

/**
 * Maps a raw `documentType` string (from `LtlDocument.documentType`) to the
 * `MessageDescriptor` used to render its label. Falls back to
 * `documentsSectionMessages.other` for any unrecognized/future document type.
 */
export const getDocumentTypeLabel = (documentType: string): MessageDescriptor =>
  DOCUMENT_TYPE_LABELS[documentType] ?? documentsSectionMessages.other;
